import type { IAuthStepEnum } from "@/template/authManagement/authStore";
import { generatePath } from "@routes/utils.ts";

export const authManagement = {
  auth: {
    route: "/auth/:type",
    link: (type: IAuthStepEnum) => generatePath("/auth/:type", { type }),
  },
};
